import { call } from 'redux-saga/effects';
import config from 'config';

import { pushWithQuery as push } from 'utils/routing';

import { serializeRequirements, journeyToRequirements } from './utils';

const pagesMap = {
  shipper: ({ shipper_id }) => `${config.BASE_ROUTE}shipper/${shipper_id}/`,
  shipper_user: ({ shipper_id, user_id }) =>
    `${config.BASE_ROUTE}shipper/${shipper_id}/user/${user_id}/`,
  carrier: ({ carrier_id }) => `${config.BASE_ROUTE}carrier/${carrier_id}/`,
  driver: ({ carrier_id, driver_id }) =>
    `${config.BASE_ROUTE}carrier/${carrier_id}/driver/${driver_id}/`,
  view_carrier_vehicles: ({ carrier_id }) => `${config.BASE_ROUTE}vehicle?carrier=${carrier_id}`,
};

function* goToVehiclesWithFilters(item) {
  yield call(
    push,
    `${config.BASE_ROUTE}vehicle?${serializeRequirements(journeyToRequirements(item))}`
  );
}

function* openPage({ payload }) {
  yield call(push, pagesMap[payload.type](payload));
}

function* openEditOrder({ payload }) {
  const { id, redirectAfterSave } = payload;
  yield call(
    push,
    `${config.BASE_ROUTE}edit_shipper_order/${id}${
      !!redirectAfterSave ? `?redirect=${redirectAfterSave}` : ''
    }`
  );
}

export { pagesMap, goToVehiclesWithFilters, openPage, openEditOrder };
